import "./TireShopLosAngeles.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import TireOffer from "./sections/TireOffer";
import Guide from "./sections/Guide";
import WhatsIncluded from "./sections/WhatsIncluded";
import TireServices from "./sections/TireServices";
import Faq from "./sections/Faq";
import UrgentCall from "./sections/UrgentCall";
import Footer from "@/reusable_sections/Footer";
export default function TireShopLosAngelesPage() {
  return <div>
      <Header />
      <Hero />
      <TireOffer />
      <Guide />
      <WhatsIncluded />
      <TireServices />
      <Faq />
      <UrgentCall />
      <Footer />
    </div>;
}